import { createTheme} from '@mui/material/styles';

const customTheme = createTheme({
    palette: {
      primary: {
        main: '#111F51',
        light: '#667899', // A suggested light shade
        dark: '#0B1338',   // A suggested dark shade
        contrastText: '#fff', // Suggested contrast text color
      },
      secondary: {
        main: '#CF1A8A',
        light: '#F773C6', // A suggested light shade
        dark: '#91105F',   // A suggested dark shade
        contrastText: '#fff', // Suggested contrast text color
      },
      background: {
        default: '#F0F2F5', // A light gray for the overall background
        paper: '#FFFFFF',   // White for paper-like components
        chatBubbleUser: '#111F51', // A very light gray with a hint of blue
        chatBubbleAI: '#CF1A8A',   // A slightly darker light gray with a hint of blue
      },
      chatbot: {
        user: '#0B1338', // A light gray for the overall background
        ai: '#CF1A8A',   // White for paper-like components
        contrastText: '#B3E5FC',   // A slightly darker light gray with a hint of blue
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.87)',
        secondary: 'rgba(0, 0, 0, 0.6)',
      },
    },
    typography: {
      // You can customize typography here (e.g., fontFamily, h1-h6 styles, body1, body2)
    },
    shape: {
      borderRadius: 4, // Default border radius
    },
    components: {
    },
  });

  export default customTheme;